import { useMemo } from "react";
import { usePropertyConfiguration } from "../../../../components/property-configuration-provider";
import { ExtrasCategoriesFlagVO } from "../../domain/valueObjects/ExtrasCategoriesFlagVO";

export function useExtrasCategoriesFlag(): boolean {
  // The provider may give null; the domain only takes undefined.
  const configuration = usePropertyConfiguration() ?? undefined;

  return useMemo(() => ExtrasCategoriesFlagVO.fromConfiguration(configuration).isActive(), [
    configuration,
  ]);
}
